import { DataActiveStatusEnum } from "../Category/types";

export interface IData {
  _id: string;
  title: string;
  shortDescription: string;
  longDescription: string;
  price: string;
  taxRate: string;
  status: DataActiveStatusEnum;
  subCategoryId: string;
  code: string;
  size: string;
  shipmentCapacity: string;
  images: IImages[];
  allergicImages: IImages[];
  stickers: IImages[];
  featuredImage: IImages[];
  createdAt: string;
  updatedAt: string;
  subCategoryTitle: string;
}
export interface IImages {
  _id: string;
  file: string;
  isRemove: boolean;
}

export enum ProductType {
  Null = "Null",
  SINGLE = "Individual Item",
  PACKAGE = "Package Item",
}

export interface ProductState {
  formData: IData;
  list: IData[];
  allList: IData[];
  allGroupList: IData[];
  loading: boolean;
  buttonLoading: boolean;
  search: string;
  pageNo: number;
  pageSize: number;
  totalRow: number;
  orderBy: string;
  orderDir: string;
  toggleLoading: boolean;
}

export type InitialState = ProductState;
